'use strict';
import { ApiServiceV2 } from '@sunrise-upc/ajax-lib';
import { API_BASE_BASEPOINT } from './api-constants';
import Cookies from 'js-cookie';
import { apiResConstants } from './APIResourceConstants';
import { v4 as generateUID } from 'uuid';
import { LinecheckBasicPropConfig } from '../../services/LinecheckBasicPropConfig';
import { errorTrackingDataLayer } from '../../utils/AnalyticsUtils';

export const getLineCheckService = (selectedAdd: any) => {
  const endPoint = LinecheckBasicPropConfig?.getInstance()?.getBaseUrl();
  const options = {
    params: {},
    headers: {
      'x-sunrise-channel': apiResConstants.X_SUN_CHAL,
      'x-correlation-id': generateUID()
    }
  };
  const requestBody: any = {
    address: selectedAdd,
    segment: 'Residential'
  };
  try {
    const URL = `${endPoint}${API_BASE_BASEPOINT.CATELOG_MGMT}${apiResConstants.LINE_CHECK}`;
    return ApiServiceV2.getApiServiceInstance()
      .post(URL, requestBody, options)
      .then((res: any) => {
        if (res.status == 200) {
          const corelationaId = res?.config?.headers?.['x-correlation-id'];
          try {
            typeof window !== 'undefined' &&
              localStorage.removeItem('one-commerce-linecheckcorrelationid');
            typeof window !== 'undefined' &&
              localStorage.setItem('one-commerce-linecheckcorrelationid', corelationaId);
          } catch {
            //
          }
          typeof window !== 'undefined' &&
            Cookies.remove('one-commerce-linecheckcorrelationid', { path: '/' });
          typeof window !== 'undefined' &&
            Cookies.set('one-commerce-linecheckcorrelationid', corelationaId, {
              path: '/',
              expires: 3
            });
          return {
            response: res?.data,
            corelationaId
          };
        }
        return [];
      })
      .catch((error) => {
        if (error?.response?.data?.code || error?.response?.status === 504) {
          errorTrackingDataLayer(error?.response);
        }
      });
  } catch (error) {
    return error;
  }
};

export const fetchLineCheck = async (payload: any) => {
  const response: any = await getLineCheckService(payload);
  const eligibleBundle = await (response?.response?.sellableProducts || []).map(
    (singleProduct: any) => singleProduct.name
  );
  const configEligibleBundle: string[] = [];
  // old code
  if (
    response?.response?.eligibleCombinations &&
    Array.isArray(response?.response?.eligibleCombinations) &&
    response?.response?.eligibleCombinations.length > 0
  ) {
    for (const element of response?.response?.eligibleCombinations) {
      for (const rate of element?.rateplans) {
        configEligibleBundle.push(rate?.name);
      }
    }
  }
  const maxUploadDownloadSpeed = response?.response?.eligibleSpeed?.maxSpeed;
  const plannedUpgrade = response?.response?.eligibleSpeed?.plannedUpgrades;
  const accessType = response?.response?.eligibleAccess;

  try {
    typeof window !== 'undefined' &&
      localStorage.setItem(
        'lineCheckResponse',
        JSON.stringify({
          eligibleBundle: eligibleBundle,
          configEligibleBundle: configEligibleBundle,
          maxUploadDownloadSpeed: maxUploadDownloadSpeed,
          plannedUpgrade: plannedUpgrade,
          originalLinecheckResponse: response?.response
        })
      );
    try {
      typeof window !== 'undefined' &&
        localStorage.setItem('one-commerce-access-type', JSON.stringify(accessType));
    } catch {
      //
    }
    //Setting expiry, for cli call accesstype required in deeplink flow
    typeof window !== 'undefined' &&
      Cookies.set('one-commerce-access-type', JSON.stringify(accessType), {
        path: '/',
        expires: 3
      });
  } catch {
    //
  }
  return {
    corelationaId: response.corelationaId,
    lineCheckResponse: response?.response,
    eligibleBundle,
    maxUploadDownloadSpeed,
    configEligibleBundle,
    plannedUpgrade
  };
};

let source: any;

export const fetchAddress = async (address: any, isValid: boolean, controllerRef: any) => {
  if (!isValid && address?.length >= 3) {
    if (controllerRef.current) {
      controllerRef.current.abort();
    }
    controllerRef.current = new AbortController();
    const signal = controllerRef.current.signal;
    const endPoint = LinecheckBasicPropConfig?.getInstance()?.getBaseUrl();

    try {
      const response = await fetch(
        `${endPoint}${API_BASE_BASEPOINT.ADDR_SUGG}${
          apiResConstants.ADDR_ENDPOINT
        }?count=${10}&address=${address.replace(/,(?=[^\s])/g, ', ')}`,
        {
          method: 'GET',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/x-www-form-urlencoded',
            'x-correlation-id': generateUID(),
            'x-sunrise-channel': apiResConstants.X_SUN_CHAL
          },
          signal: signal
        }
      );

      const data = await response.json();
      if (data) {
        const addressRes: any[] = [];
        data?.items &&
          data?.items.forEach((item: any) => {           
            if (item?.street && item?.houseNumber && item?.postCode && item?.city) {
              item.concatedAddress = `${item?.street} ${item?.houseNumber},${item?.postCode} ${item?.city}`;
              addressRes.push(item);
            }
          });
        return addressRes;
      }
    } catch (error) {
      console.log(error);
    }
  }
  //}
};
